import { APIRoute } from '@/modules/utils'
import { MemberProfile } from '@/dataV3/User/MemberProfile'

export const Route: APIRoute = {
  method: 'GET',
  path: '/member/:memberId',
}

export type UrlParams = {
  memberId: string
}

export type Response = MemberProfile
